import { actions } from "./oversiktActions";

const initialState = {
    data: {},
    fetched: false,
    loading: false,
    error: ''
}

export default function oversiktReducer (state = initialState, action) {

    switch (action.type) {

        case actions.OVERSIKT_LOADING:
            return {
                ...state,
                fetched: false,
                loading: true,
                error: null
            };

        case actions.OVERSIKT_DATA_FETCHED:
            return {
                ...state,
                data: { ...action.payload },
                fetched: true,
                loading: false,
                error: null
            };

        case actions.OVERSIKT_ERROR:
            return {
                ...state,
                loading: false,
                fetched: true,
                error: action.data
            }

        default:
            return state;
    }
}
